import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoschUiIconComponent } from '../bosch-ui-icon/bosch-ui-icon.component';
import { BoschUiIconNames } from '../bosch-ui-icon/bosch-ui-icon.constants';

@Component({
  selector: 'bosch-ui-validation-error',
  standalone: true,
  imports: [CommonModule, BoschUiIconComponent],
  templateUrl: './bosch-ui-validation-error.component.html',
  styleUrls: ['./bosch-ui-validation-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiValidationErrorComponent {
  @Input() error: string | null = null;
  readonly alertErrorIcon: BoschUiIconNames = BoschUiIconNames.AlertError;
}
